export class DeliveryExceptionSearchModel {
  id: string;
  name: string;
  reason: string;
  exceptions: string;
  state: string;
}
